export default "__VITE_ASSET__Br1JqGlD__"